import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Tooltip, Fab } from '@mui/material';
import { styled } from '@mui/material/styles';

import Scrollbar from '../../../../components-core/Scrollbar';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components-core/data-grid/DataGridToolbar';
import { promotionColumns } from '../../../../services/column-definitions';
import PromotionDetails from './PromotionDetails';

const RootStyle = styled('div')({
  flexGrow: 1,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column'
});


export const PromotionList = props => {
  const { onOpenSidebar, hideSidebar, promotions, queryCallback, loading, submitCallback, allSeasons, createSignal, turnOffCreateSignal } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);

  const handleDetailsCheck = data => {
    setEditRowData(data);
    setFullScreen(true);
    setOpenCompose(true);
  };

  React.useEffect(() => {
    if (createSignal) {
      setEditRowData(null);
      setFullScreen(true);
      setOpenCompose(true);
      turnOffCreateSignal();

    }
  }, [createSignal]);

  const [columns, setColumns] = React.useState(promotionColumns(handleDetailsCheck));

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <RootStyle sx={{ opacity: loading ? 0.5 : 1 }}>
      { openCompose &&
      <PromotionDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
        allSeasons={allSeasons}
      />
      }
      {/* <Scrollbar> */}
      <Box sx={{ minWidth: { md: 800 } }}>
        <DataGridPro
          columns={columns}
          rows={promotions}
          density="compact"
          disableColumnMenu={true}
          autoPageSize={false}
          autoHeight={true}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: false, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
          onRowClick={params => {
            setEditRowData(params.row);
            setOpenCompose(true);
          }}
          onRowDoubleClick={params => {
            setEditRowData(params.row);
            setFullScreen(true);
            setOpenCompose(true);
          }}
        />
      </Box>
      {/* </Scrollbar> */}
    </RootStyle>
  );
};

PromotionList.propTypes = {
  onOpenSidebar: PropTypes.func
};
